import { create } from "zustand";

/**
 * Shared state between MessageBanner and the Navbar restore pill.
 * Dismissal is in-memory by design: workstations are shared across shifts, so
 * a refresh must bring every active message back.
 */
export const useBannerStore = create((set) => ({
  dismissed: false,
  count: 0,
  topPriority: null,

  dismiss: () => set({ dismissed: true }),
  restore: () => set({ dismissed: false }),
  setSummary: (count, topPriority) => set({ count, topPriority }),
}));
